/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Table, Thead, Tr, Th, Tbody, Td } from "@chakra-ui/react";

import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";

const LedgerTable = ({ ledgerData, total }) => {
  const renderGstLabels = (gst, invoiceGst) => {
    const gstEntries = [
      { key: 'cgst', label: 'CGST' },
      { key: 'sgst', label: 'SGST' },
      { key: 'igst', label: 'IGST' }
    ];

    return gstEntries.map(({ key, label }) => 
      (gst?.[key] || invoiceGst?.[key]) ? <p key={key} className="bold-text">{label}</p> : null
    );
  };

  const renderGstAmounts = (gst, invoiceGst) => {
    const gstEntries = [
      { key: 'cgst' },
      { key: 'sgst' },
      { key: 'igst' }
    ];

    return gstEntries.map(({ key }) => 
      (gst?.[key] || invoiceGst?.[key]) ? (
        <p className="bold-text" key={key}>
          <Box display="flex">
            {gst?.[key] ? (
              <span>{formatAmountInINR(gst?.[key])} Dr</span>
            ) : (
              <span>{formatAmountInINR(invoiceGst?.[key])} Cr</span>
            )}
          </Box>
        </p>
      ) : null
    );
  };

  const renderTransactionRows = (transactions, type,amountType) => {
    return transactions.map((transaction, index) => (
      <Tr key={index}>
        <Td>{dateTimeFormat(transaction?.date)} {type}</Td>
        <Td>
          <p className="bold-text">{transaction?.bank || transaction?.pmtId} {transaction?.refNo ? `(${transaction?.refNo})` : ""}</p>
        </Td>
        <Td>
          <p className="bold-text">{type === 'To' ? 'Payment' : 'Received'}</p>
        </Td>
        <Td></Td>
        <Td className="amount">
          {amountType === "Paid" ? <p>{formatAmountInINR(transaction?.amount)}</p> : ""}
        </Td>
        <Td >{amountType === "Received" ? <p>{formatAmountInINR(transaction?.amount)}</p>:""}
        </Td>
      </Tr>
    ));
  };

  return (
    <Table>
      <Thead className="heading">
        <Tr>
          <Th>Date</Th>
          <Th>Particular</Th>
          <Th>Vch Type</Th>
          <Th>Pr No.</Th>
          <Th>Debit</Th>
          <Th>Credit</Th>
        </Tr>
      </Thead>
      <Tbody className="mt-3">
        {ledgerData && ledgerData.length ? ledgerData.map((item, index) => {
          const { spent, received, gstDetails: gst, tdsDetails: tds, invoiceGst, invoiceTds, category } = item;
          return (
            <React.Fragment key={index}>
              <Tr className="pt-3">
                <Td className="top-fixed">
                  {item?.creditDate ? <span>{dateTimeFormat(item?.creditDate)} By</span> : <span>{dateTimeFormat(item?.debitDate)} To</span>}
                </Td>
                <Td>
                  <p className="bold-text">{item?.poNo || item?.inNo} {gst?.percentage ? `(${gst?.percentage}%)` : ""}</p>
                  {renderGstLabels(gst, invoiceGst)}
                  {tds?.amount ? <p className="bold-text">Tds {tds?.isTdsPo ? `(${tds?.tdsPO})` : ""}</p> : ""}
                  {invoiceTds?.amount ? <p className="bold-text">Tds</p> : ""}

                </Td>
                <Td>
                  <p className="bold-text">Journal</p>
                  {renderGstAmounts(gst, invoiceGst)}
                  {tds?.amount ? (
                    <p className="bold-text"><Box display="flex">{formatAmountInINR(tds?.amount)} Cr</Box></p>
                  ) : invoiceTds?.amount ? (
                    <p className="bold-text"><Box display="flex">{formatAmountInINR(invoiceTds?.amount)} Dr</Box></p>
                  ) : null}
                </Td>
                <Td className="top-fixed">{item?.poNo || item?.inNo}</Td>
                <Td>
                  {category === 'tds' && item?.creditAmount ? formatAmountInINR(item?.creditAmount) : item?.debitAmount ? formatAmountInINR(item?.debitAmount) : ""}
                </Td>
                <Td className="amount">{item?.creditAmount ? <p>{category !== 'tds' ? formatAmountInINR(item?.creditAmount) : ""}</p> : null}</Td>
              </Tr>
              {spent && category !== 'tds' && spent.length > 0 ? renderTransactionRows(spent, 'To','Paid') : null}
              {received && received.length > 0 ? renderTransactionRows(received, 'BY','Received') : null}
            </React.Fragment>
          );
        }) : null}
        <Tr>
          <Td></Td>
          <Td></Td>
          <Td></Td>
          <Td></Td>
          <Td className="border-top">{total?.totalDebit ? formatAmountInINR(total?.totalDebit) : Number(0).toFixed(2)}</Td>
          <Td className="border-top">{total?.totalCredit ? formatAmountInINR(total?.totalCredit) : Number(0).toFixed(2)}</Td>
        </Tr>
        <Tr className="mt-2">
          <Td>By</Td>
          <Td><p className="bold-text">Closing Balance</p></Td>
          <Td></Td>
          <Td></Td>
          <Td className="border-bottom">{total?.closingBal > 0 ? formatAmountInINR(total?.closingBal) : ''}</Td>
          <Td className="border-bottom">{total?.closingBal < 0 ? formatAmountInINR(Math.abs(total?.closingBal)) : Number(0).toFixed(2)}</Td>
        </Tr>
        <Tr className="mt-2">
          <Td></Td>
          <Td></Td>
          <Td></Td>
          <Td></Td>
          <Td className="border-bottom bold-text">{total?.closingBal > 0 ? formatAmountInINR(total?.totalDebit + total?.closingBal) : total?.totalDebit ? formatAmountIndianRupees(total?.totalDebit) : Number(0).toFixed(2)}</Td>
          <Td className="border-bottom bold-text">{total?.closingBal < 0 ? formatAmountInINR(total?.totalCredit + Math.abs(total?.closingBal)) : total?.totalCredit ? formatAmountIndianRupees(total?.totalCredit) : Number(0).toFixed(2)}</Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default LedgerTable;
